export function EmergingMarket() {
  const marketFactors = [
    {
      icon: 'ri-line-chart-line',
      title: 'Rapid Growth',
      description: 'Surrey is BC\'s fastest-growing city with over 600,000 residents and expanding urban centers creating strong rental demand.'
    },
    {
      icon: 'ri-building-line',
      title: 'Urban Development',
      description: 'Major development in Surrey Central, City Centre, and Guildford areas driving increased business travel and accommodation needs.'
    },
    {
      icon: 'ri-train-line',
      title: 'Transit Expansion',
      description: 'SkyTrain extensions and improved transit infrastructure making Surrey increasingly accessible for visitors and business travelers.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Lower property costs compared to Vancouver create attractive investment opportunities with strong rental yield potential.'
    },
    {
      icon: 'ri-community-line',
      title: 'Diverse Neighborhoods',
      description: 'Multiple distinct communities from urban centers to suburban areas offering varied rental market opportunities.'
    },
    {
      icon: 'ri-government-line',
      title: 'Evolving Regulations',
      description: 'Surrey is actively developing its STR framework, creating opportunities for early compliant operators to establish presence.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Surrey's Emerging Rental Market
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            BC's fastest-growing city presents unique opportunities for short-term rental operators. Understanding the market dynamics is key to success.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {marketFactors.map((factor, index) => (
            <div 
              key={index}
              className="bg-[#F0F0F0] rounded-2xl p-8 hover:shadow-lg transition-all"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#882629] rounded-xl mb-6">
                <i className={`${factor.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-3">
                {factor.title}
              </h3>
              <p className="text-[#505A5A]/70 leading-relaxed">
                {factor.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
